import React from 'react';

function PlaceholderCard({ title, description }: { title: string; description: string }) {
  return (
    <div className="mx-auto max-w-2xl rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm dark:border-neutral-700 dark:bg-neutral-900">
      <h2 className="text-lg font-semibold text-slate-900 dark:text-white">{title}</h2>
      <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">{description}</p>
    </div>
  );
}

/** Cancelled / churned subscriptions — content TBD. */
export const AdminCancelledSubscriptionsPage: React.FC = () => (
  <div className="p-6">
    <PlaceholderCard
      title="Cancelled Subscription"
      description="This view will list cancelled or expired paid plans. More detail and actions will be added here."
    />
  </div>
);
